const coins = require('../coins');
const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = [{
    dataIndex: 0,
    id: '3pool',
    name: '3pool',
    lpTokenInfo: {
        name: '3poolCurve',
        symbol: '3poolCrv',
    },
    assets: 'DAI+USDC+USDT',
    coins: [
        coins.dai,
        coins.usdc,
        coins.usdt,
    ],
    addresses: {
        swap: '0xbF7E49483881C76487b0989CD7d9A8239B20CA41',
        lpToken: '0xbF7E49483881C76487b0989CD7d9A8239B20CA41',
        gauge: '0xC2b1DF84112619D190193E48148000e3990Bf627',
    },
    hasNoGauge: true,
    // gaugeVersion: 3, // No CRV rewards
    hasNoCRVRewards: true,
  }
];
